export const phoneRegex = new RegExp(
  /([0-9s-]{7,})(?:s*(?:#|x.?|ext.?|extension)s*(d+))?$/,
  'i',
);
